import type { DashboardMetricValue } from '@/entities/Dashboard';
import type { MetricItem } from '../config/mockDashboardData';

export type MetricKind = 'count' | 'percent' | 'grade';

const roundValue = (value: number) => Math.round(value * 10) / 10;

export const formatMetricValue = (value: number | null | undefined, kind: MetricKind): string => {
  if (value === null || value === undefined) {
    if (kind === 'grade') return '0/100';
    if (kind === 'percent') return '0%';
    return '0';
  }

  if (kind === 'percent') return `${roundValue(value)}%`;
  if (kind === 'grade') return `${roundValue(value)}/100`;
  return roundValue(value).toLocaleString();
};

export const buildMetric = (
  id: string,
  title: string,
  metric: DashboardMetricValue | undefined,
  kind: MetricKind,
): MetricItem => ({
  id,
  title,
  value: formatMetricValue(metric?.value ?? null, kind),
  change: metric?.diff ?? null,
  higherIsBetter: metric?.higherIsBetter ?? true,
});
